<template>
  <el-popover
    placement="top-start"
    width="200"
    trigger="hover"
    v-if="document && document.sharedTags && document.sharedTags.length > 0"
  >
    Đã chia sẻ đến thư mục:
    <b>{{
      document.sharedTags
        .slice(0, 2)
        .map((t) => t.name)
        .join(', ')
    }}</b>
    <span v-if="document.sharedTags.length > 2">và {{ document.sharedTags.length - 2 }} thư mục khác</span>
    <FAIcon slot="reference" icon="fas fa-users" :color="Colors.SEND" :clickable="true" @click="$emit('click')" />
  </el-popover>
</template>

<script>
import FAIcon from '@/components/common/FAIcon.vue'
import { Colors } from '@/constants/DoITConstant.js'

export default {
  name: 'DocumentSharingStatus',
  components: { FAIcon },
  props: {
    document: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      Colors,
    }
  },
}
</script>

<style scoped></style>
